import React, { useContext } from "react";

import { Container, Row, Image } from "react-bootstrap";
import TestCard from "../components/TestCard";
import Header from "../components/Header";
import EsferasResultados from "../components/resultados/EsferasResultados";
import ConcluDiagnos from "../components/resultados/ConcluDiagnos";
import RazonaClini from "../components/resultados/RazonaClini";
/* import Navbar from '../components/Navbar' */
import Context from "../Context";
import EsferasMUInestedMenu from "../components/resultados/EsferasMUInestedMenu";


const Resultados = () => {
  const { showLogo } = useContext(Context);
  return (
    <section id="resultados">
       { showLogo && <Image
          className="logoPDF"
          src="./assets/images/cmf-logo.png"
          alt="logo cmf"
        /> }
      <Header title="Resultados" />

      {/* <Container> */}
      {/* <Row className="justify-content-md-center">  */}

      <div className="wraper-cards">
       {/*  <EsferasResultados /> */}
       <EsferasMUInestedMenu />
        <ConcluDiagnos />
        <RazonaClini />
      </div>

      {/* </Row> */}
      {/* </Container> */}
    </section>
  );
};

export default Resultados;
